import styled, { css } from 'styled-components';
import media from '../../../../constants/media';
import { StyledCheckbox } from '../checkbox';

export const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	border-radius: 3px;
	transition: box-shadow 150ms, border-color 150ms;
	margin-bottom: 2rem;

	input[type='checkbox'] {
		display: none;
	}

	&:last-child {
		margin-bottom: 0;
	}

	&:hover {
		${StyledCheckbox}:after {
			opacity: 1;
		}
	}

	${({ checked }) =>
		checked &&
		css`
			border-color: ${({ theme }) => theme.colors.secondary};
			box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.1);
		`};
`;

export const SimpleWrapper = styled.div`
	position: relative;
	background: ${({ theme }) => theme.colors.grayLighter};
	padding: 1rem;

	input[type='checkbox'] {
		display: none;
	}

	label {
		display: flex;
		cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

		> div:first-child {
			position: relative;
			width: 4rem;
		}

		> div:last-child {
			flex: 1;

			> div:last-child {
				font-size: 1.5rem;
			}
		}
	}

	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.5;
		`};
`;

export const DisabledMessage = styled.div`
	font-size: 1.3rem;
	color: ${({ theme }) => theme.colors.primaryLight};
	margin-top: 0.5rem;
	font-style: italic;
`;

export const CheckboxTileLabel = styled.label`
	display: block;
	padding: 2.5rem;
	padding-bottom: 7rem;
	cursor: pointer;
	transition: padding 150ms;

	${({ active }) =>
		active &&
		css`
			padding-bottom: 0.5rem;
		`};

	${media.tablet`
		padding: 3.5rem;
		padding-bottom: 5rem;

		${({ active }) =>
			active &&
			css`
				padding-bottom: 3.5rem;
			`};
	`};
`;

export const TileCheckbox = styled(StyledCheckbox)`
	/* left: 2.5rem;
	top: 2.5rem;
	right: auto;
	bottom: auto; */
	top: auto;
	right: 3.5rem;
	bottom: 1.5rem;
	left: auto;
	transform: scale(0.8);

	${({ checked }) =>
		checked &&
		css`
			transform: scale(1);
		`};

	${media.tablet`
		top: auto;
		right: 3.5rem;
		bottom: 1.5rem;
		left: auto;
	`};
`;

export const Top = styled.div`
	${media.tablet`
		display: flex;
		align-items: center;
		justify-content: space-between;
	`};
`;

export const TopLeft = styled.div`
	display: flex;
	flex-direction: column;
	align-items: left;
	text-align: left;

	${media.tablet`
		flex-direction: row;
		text-align: left;
	`};
`;

export const IconWrapper = styled.div`
	margin-right: 1.5rem;
	display: none;

	svg {
		width: 4.5rem;
		height: 4.5rem;
		path:first-child {
			fill: ${({ theme }) => theme.colors.grayLighter3};
			stroke-width: 0;
		}
		path {
			stroke: ${({ theme }) => theme.colors.grayLighter3};
		}
		line {
			stroke: ${({ theme }) => theme.colors.grayLighter3};
		}
	}

	${({ checked }) =>
		checked &&
		css`
			svg {
				path:first-child {
					fill: ${({ theme }) => theme.colors.secondary};
					stroke-width: 0;
				}
				path {
					stroke: ${({ theme }) => theme.colors.secondary};
				}
				line {
					stroke: ${({ theme }) => theme.colors.secondary};
				}
			}
		`};

	${media.tablet`
		display:flex;
	`}
`;

export const LabelText = styled.div`
	font-size: 2rem;
	color: ${({ theme }) => theme.colors.black};
	margin: auto;
`;

export const PriceWrapper = styled.div`
	text-align: left;
	position: absolute;
	top: auto;
	left: 2.5rem;
	bottom: 1.5rem;
	right: auto;

	${media.tablet`
		text-align: right;
		position: inherit;
		top: auto;
		left: auto;
		bottom: auto;
		right: auto;
	`}
`;

export const PriceLabel = styled.div`
	font-size: 1.4rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	color: ${({ theme }) => theme.colors.black};
`;

export const PriceValue = styled.div`
	font-size: 3rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	line-height: 1;
	color: ${({ theme }) => theme.colors.primary};
`;

export const ChildWrapper = styled.div`
	padding: 0 2.5rem 7.5rem;
`;
